export default (data, colIndex, order) => { 
    return data.sort((a, b) => { 
        if (colIndex === 0) { 
            var va = new Date(moment(a.data[colIndex],"DD/MM/YYYY hh:mm:ss").format("l"));
            var va = new Date(moment(b.data[colIndex],"DD/MM/YYYY hh:mm:ss").format("l"));
            return (new Date(va) < new Date(vb) ? -1: 1 ) * (order === 'desc' ? 1 : -1); 
        }
        //String ou Outros
        else { 
            return (a.data[colIndex] < b.data[colIndex] ? -1: 1 ) * (order === 'desc' ? 1 : -1); 
        }
    });
};